import React, { Dispatch, SetStateAction, useMemo } from 'react';
import { Layer } from 'react-konva';
import { PointDetection } from '../../services/data/impl/wrangler/schemas/pointDetections';
import { ImageScaleParams } from './ImageController';
import { MaskTooltipInfo } from './ImageStage';
import Masks from './Masks';

interface Props {
  pointCubeDetections: PointDetection[] | null;
  imageScaleParams: ImageScaleParams;
  imageWidth: number;
  imageHeight: number;
  setMaskTooltipInfo: Dispatch<SetStateAction<MaskTooltipInfo>>;
}

const MaskLayers: React.FC<Props> = ({
  pointCubeDetections,
  imageScaleParams,
  imageWidth,
  imageHeight,
  setMaskTooltipInfo,
}) => {
  const masks = useMemo(() => {
    return pointCubeDetections?.map((detection, i) => (
      <Masks
        key={i}
        detections={detection}
        imageScaleParams={imageScaleParams}
        imageWidth={imageWidth}
        imageHeight={imageHeight}
        setMaskTooltipInfo={setMaskTooltipInfo}
      />
    ));
  }, [
    pointCubeDetections,
    imageScaleParams,
    imageWidth,
    imageHeight,
    setMaskTooltipInfo,
  ]);

  if (!pointCubeDetections || pointCubeDetections.length === 0) {
    return null;
  }

  return <Layer>{masks}</Layer>;
};

export default MaskLayers;
